import { useMemo } from "react";
import {
  type Control,
  Controller,
  type FieldValues,
  type Path,
} from "react-hook-form";

import { MultiSelect2 } from "@/components/multi-select-2/MultiSelect2";
import { useResolveRequests } from "@/features/users/hooks/useResolveRequests";

type AssignedRequestsProps<T extends FieldValues> = {
  control: Control<T>;
  name: Path<T>;
  projectIds: null | number[];
};

export function AssignedRequests<T extends FieldValues>({
  control,
  name,
  projectIds,
}: AssignedRequestsProps<T>) {
  const { data } = useResolveRequests(projectIds ?? []);

  const accounts = useMemo(
    () =>
      (data || [])
        .filter((d) => d.requestId != null)
        .map((d) => ({
          avatar: undefined,
          description: d.projectName,
          href: `/requests/edit/${d.requestId}`,
          id: d.requestId,
          textValue: d.requestName,
        })),
    [data],
  );

  return (
    <div className="space-y-2 mt-4">
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <MultiSelect2
            isDisabled={!projectIds?.length}
            label="Assigned requests"
            onRemove={(key) => {
              field.onChange(
                field.value.filter((id: number) => id !== Number(key)),
              );
            }}
            onSelect={(key) => {
              const numKey = Number(key);

              if (!field.value.includes(numKey)) {
                field.onChange([...field.value, numKey]);
              }
            }}
            options={accounts}
            placeholder="Search to add brands..."
            selectedIds={field.value}
          />
        )}
      />
    </div>
  );
}
